export enum LegalityTypes {
  LEGAL = 'd90f05bf-6baf-4f86-9ca3-9501af6901ea',
  ILLEGAL = 'ae5de668-67ac-4650-af26-23dd0cb97c89',
}
